const BaseURL = "https://rastrack-api.compgovpartners.com/api/";
// const BaseURL = "https://dev-cgp.upworkdeveloper.com/api/";

const Endpoint = {
  auth: {
    login: "adminLogin",
    resetPassword: "reset-password",
    forgotPassword: "adminForgotPassword",
    logout: "logout",
    passwordRequests: "admin/getPasswordRequests",
    deleteRequest: "admin/passwordRequest/:id",
    generatePassword: "admin/acceptPasswordRequest/:id",
  },
  questionnaire: {
    getLevelOfWorkDropdowns: "questions/dropdowns",
    getAllDropdownsWithOptions: "questions/dropdown-options",
    getAppOutComes: "questions/app-outcomes",
    editQuestion: "admin/editQuestion/:id",
    editOption: "admin/editOption/:id",
    getQuestionaire: "admin/questionaire",
    getQuestions: "questions/getQuestions",
  },
  evaluations: {
    addDraftEvaluation: "admin/draftRequestedEvaluation/:id",
    activateEvaluation: "admin/activateEvaluation/:id",
    deActivateEvaluation: "admin/deactivateEvaluation/:id",
    activateEvaluationVersion: "admin/activateEvaluationVersion/:id",
    deleteEvaluationVersion: "admin/version/:id",
    getCurrentVersionDetails: "admin/getVersionDetails/:id",
    getSingleEvaluation: "admin/singleEvaluationVersions/:id",
    getOrganizationEvaluations: "admin/listEvaluations/:id",
    updateEvaluation: "admin/updateEvaluation/:id",
    pendingEvaluations: {
      get: "admin/listRequests",
      getSingle: "admin/request/:id",
      add: "admin/addRequestedEvaluation/:id",
      getOrgList: "admin/listRequestsByOrg/:id",
    },
    download: "admin/downloadEvaluations",
    downloadAll: "admin/downloadEvaluations/:id",
  },
  organization: {
    add: "admin/addOrganization",
    list: "admin/listOrganizations",
    edit: "admin/editOrganization/:id",
    delete: "admin/deleteOrganization/:id",
    getSingleOrganization: "admin/organizationEditScreenDetails/:id",
    disable: "admin/disableOrganization/:id",
    activate: "admin/enableOrganization/:id",
  },
  dashboard: {
    stats: "admin/dashboardStats",
    graphStats: "admin/graphStats",
    organizationsStats: "admin/organizationStats",
    newOrganizationsStats: "admin/newOrganizationStats",
  },
  general: {
    listUsers: "listings/users",
    listOptions: "listings/options",
    listComplaints: "admin/listComplaints",
    deleteComplaint: "admin/customerComplaint/:id",
    count: "admin/countsData",
    uploadFile: "admin/uploadUserManual",
  },
  notifications: {
    get: "notification/listNotifications",
    readAll: "notification/markAllAsRead",
    count: "notification/notificationCount",
  },
};

export { Endpoint, BaseURL };
